export function formatDate(input: string): string {
    const date = new Date(input);

    // Extract components
    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const seconds = date.getUTCSeconds().toString().padStart(2, '0');

    // Combine into the desired format
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}